import { useTheme } from "@mui/material/styles";

const containerBoxStyles = (theme) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  [theme.breakpoints.up("xl")]: {
    marginLeft: "2%",
    marginRight: "2%",
  },
  [theme.breakpoints.up("md")]: {
    marginLeft: "2%",
    marginRight: "2%",
  },
  pt: 2,
  pb: 2,
  alignItems: "center",
});

const buttonStyles = {
  minWidth: "0px",
  "& .MuiButton-startIcon": {
    mr: 0,
    ml: 0,
  },
};

const headerButtonStyles = {
  minWidth: "0px",
  backgroundColor: "#E4F2E8",
  color: "black",
  marginLeft:'5px',
  borderRadius:'50%',
  p:1.5,
  "& .MuiButton-startIcon": {
    mr: 0,
    ml: 0,
  },
};

const badgeColor={
  color: "white",
  "& .MuiBadge-badge": {
    backgroundColor:'#7AB5BD '
  },
}

const buttonBoxStyles = {
  display: "flex",
  alignItems: "center",
};

export { containerBoxStyles, buttonStyles, buttonBoxStyles, headerButtonStyles,badgeColor };
